export const Infographic = ({ title, description, icon, color }) => {
  // text-[#862633]
  // text-[#003b5c]
  // text-[#77c5d5]
  // text-[#ffc845]
  // text-[#8f993e]
  // text-[#ff7f41]

  // bg-[#862633]
  // bg-[#003b5c]
  // bg-[#77c5d5]
  // bg-[#ffc845]
  // bg-[#8f993e]
  // bg-[#ff7f41]

  let textColor = 'text-white'
  if (color === '#ffc845' || color === '#77c5d5' || color === '#ff7f41') {
    textColor = 'text-black'
  }

  return (
    <div class="data relative flex w-full flex-row gap-3 p-4 pl-2">
      {icon && (
        <span
          className={`-mt-px flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${color ? 'bg-[' + color + ']' : 'bg-sv-crimson'}`}
        >
          <i
            class={`fas text-lg fa-${icon} relative top-0 left-0 text-white`}
          ></i>
        </span>
      )}
      <div>
        <span class="flex items-baseline font-display text-3xl font-bold">
          {title && title}
        </span>
        {description && (
          <p class="m-0 mt-2 max-w-prose p-0 text-base leading-normal text-neutral-500">
            {description}
          </p>
        )}
      </div>
    </div>
  )
}
